import { useEffect, useState } from "react";
import MarketingLayout from "@/components/layout/MarketingLayout";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { api } from "@/lib/api";

export default function FAQs() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/cms/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);

  return (
    <MarketingLayout>
      <section className="page-shell px-6 py-20">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">FAQs</div>
          <h1 className="font-display text-5xl lg:text-6xl mt-3">Everything you might wonder.</h1>
        </div>
        <div className="mt-10 max-w-3xl">
          <Accordion type="single" collapsible data-testid="faqs-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`f-${i}`}>
                <AccordionTrigger data-testid={`faqs-trigger-${i}`}>{f.q}</AccordionTrigger>
                <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </MarketingLayout>
  );
}
